module.exports = __webpack_public_path__ + "img/github-logo.5f61d38f.svg";